import { addDays, format } from "date-fns";
import { ProgressSpinner } from "primereact/progressspinner";
import { useEffect, useState } from "react";
import { GrDocumentPdf } from "react-icons/gr";
import { useAuth } from "../contexts/AuthInfoContext";
import { useNegotiation } from "../contexts/NegotiationContext";
import { usePrivate } from "../contexts/PrivateInfoContext";
import { criaTermo } from "../services/requests/getTermo";

function TermoNovacao() {
  const { user_id, provider_id } = useAuth();
  const {
    parcelaValor,
    tipoPagamento,
    ip,
    valorTotalSemDesconto,
    valorComDesconto,
    parcelasDescontoParcelas,
    descontoTipo,
    entrada,
    boletoVencimento,
    descontoAplicavel,
    cobrancas,
    taxaEnvioProtesto,
    taxaPrimeiraParcelaProtesto,
    providerWlan,
    multaQuebrada,
    jurosQuebrada,
    cobrancasSelecionadas,
    tipoNegociacao,
  } = usePrivate();
  const { termoData, setPdf } = useNegotiation();
  const valor_parcela_entrada = providerWlan ? entrada : tipoPagamento === "B" ? (entrada + 2.9) / 0.99 : null;
  const valor_com_desconto_negociacao = descontoAplicavel ? valorComDesconto : valorTotalSemDesconto;
  const parcelas_negociacao =
    descontoTipo === "parcela" || (descontoTipo === "boleto" && descontoAplicavel)
      ? parcelasDescontoParcelas
      : parcelaValor;

  const [termo, setTermo] = useState("");

  useEffect(() => {
    const geraTermo = async () => {
      setPdf("");
      const termoRequisicaoData = {
        devedor_id: user_id,
        credor_id: provider_id,
        qt_parcelas: parcelas_negociacao.numero_parcela,
        valor_parcelas: parcelas_negociacao.valor_parcela,
        valor_entrada: entrada > 0 ? String(valor_parcela_entrada) : null,
        vencimento: format(addDays(new Date(), boletoVencimento), "yyyy-MM-dd"),
        valor_total: valor_com_desconto_negociacao.toFixed(2),
        ip_devedor: ip,
        multa: multaQuebrada === "0" ? cobrancas[0].multa : multaQuebrada,
        juros: jurosQuebrada === "0" ? cobrancas[0].juros : jurosQuebrada,
        taxa_envio: Number(taxaPrimeiraParcelaProtesto ? taxaEnvioProtesto : 0),
        tipo_negociacao: tipoNegociacao,
        cobrancas: cobrancasSelecionadas,
      };
      //console.log(entrada>0, valor_parcela_entrada)
      const data = await criaTermo(termoRequisicaoData);
      //console.log(data)
      setTermo(data.base64_pdf_termo);
      termoData(data.base64_pdf_termo);
    };
    geraTermo();
  }, []);
  return (
    <div className="h-[63vh]">
      {termo !== "" ? (
        //<iframe title="Termo de Novação" src={`data:application/pdf;base64,${termo}`} width={'100%'} height={"800px"}  /> :
        <object data={`data:application/pdf;base64,${termo}`} type="application/pdf" width={"100%"} height={"100%"}>
          <div>
            <p>Faça download do termo</p>
            <div className="flex p-[1vh] justify-center">
              <i className="text-6xl">
                <GrDocumentPdf></GrDocumentPdf>
              </i>
            </div>
            <p>
              <a href={`data:application/pdf;base64,${termo}`}>Clique para baixar o termo</a>
            </p>
          </div>
        </object>
      ) : (
        <ProgressSpinner strokeWidth="6" fill="transparent" animationDuration=".5s" />
      )}
    </div>
  );
}

export default TermoNovacao;
